<template>
  <modal :show="show" @close="close">
    <div class="modal-header">
      <h3>{{ titleCase(errorType) }}</h3>
    </div>

    <div>
      <br/>
      <b>{{ titleCase(errorMsg) }}</b>
    </div>

    <div class="modal-footer text-right">
      <v-btn color="deep-orange" dark @click="close">
        OK
      </v-btn>
    </div>
  </modal>
</template>

<script>
import Modal from "./Modal";

export default {
  name: "error-modal",
  components: { Modal },
  props: ["show", "errorType", "errorMsg"],
  methods: {
    titleCase(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    },
    close() {
      this.$emit("close");
    }
  },
  mounted() {
    // Enter keypress
    document.addEventListener("keydown", e => {
      if (this.show && e.keyCode === 13) {
        this.checkForm();
      }
    });
  }
};
</script>

<style>
.button-success {
  color: #fff !important;
  background-color: #4caf50 !important;
  border-color: #4caf50 !important;
}
</style>
